import React from 'react'
import { BuildWithAICore, type BuildWithAIAgentConfig } from '@bizfirst/build-with-ai-core'

/**
 * Flow Studio-specific wrapper around the shared `BuildWithAICore` shell (tabs, cards,
 * prompt-copy, icons) in `@bizfirst/build-with-ai-core`. Flow Studio has no MCP bridge yet, so
 * this wrapper just supplies the agent prompt -- no extra cards/steps. See
 * `AppStudioBuildWithAIPage` in `app-studio-designer/src/buildWithAi/` for the studio that does.
 */

export type FlowStudioBuildWithAIAgentConfig = BuildWithAIAgentConfig

export interface FlowStudioBuildWithAIPageProps {
  agent: FlowStudioBuildWithAIAgentConfig
  theme?: 'light' | 'dark'
}

const PROMPT_TEXT =
  'Read the content from the opened page and download the agent details and skills from the ' +
  'mentioned GitHub path. Fully cover the GitHub instructions: follow every linked ' +
  'knowledge and procedure doc the agent index points to for this task — including design ' +
  'patterns and style/theme docs whenever the task involves a theme, color, or look and feel — ' +
  'not just the entry-point files needed to start. Then follow the execution steps mentioned in ' +
  'the agent, and do not report styling or theming as done unless it was actually applied per ' +
  'that guidance. Before reporting the build as finished, open the real running workflow (not ' +
  'just the Designer canvas) with a hard reload and visually confirm it actually renders and runs ' +
  'as expected — a Designer-only check does not count as done.'

export const FlowStudioBuildWithAIPage: React.FC<FlowStudioBuildWithAIPageProps> = ({ agent, theme = 'dark' }) => (
  <BuildWithAICore agent={agent} theme={theme} promptText={PROMPT_TEXT} />
)

export default FlowStudioBuildWithAIPage
